import BackTop from './src/back-top'

export default BackTop
